import React, { Component } from 'react';
import { CardElement, injectStripe } from 'react-stripe-elements';
import { Field, reduxForm } from 'redux-form';
import { toastr } from 'react-redux-toastr';
import Button from 'react-bootstrap-button-loader';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AdvertiserApi } from '../../../api';
import { setLoader, removeLoader } from '../../../actions';
import { InputField, required } from '../../form';

class StripeForm extends Component {
  submit = (values) => {
    const { dispatch, account, handleHide } = this.props;
    dispatch(setLoader('CardForm'));

    this.props.stripe.createToken({
      name: values.name,
      address_city: values.address_city,
      address_country: values.address_country,
      address_line1: values.address_line1,
      address_line2: values.address_line2,
      address_state: values.address_state,
      address_zip: values.address_zip
    }).then((res) => {
      const { token, error } = res;
      if (error) {
        dispatch(removeLoader('CardForm'));
        toastr.error(error.message);
      } else {
        dispatch(AdvertiserApi.actions.cardCreate.post({ token_id: token.id, account_id: account.uuid }, (_error, success) => {
          dispatch(removeLoader('CardForm'));
          if (success) {
            toastr.success('Card has been added successfully');
            handleHide();
            dispatch(AdvertiserApi.actions.cards.get({ account_id: account.uuid }));
            dispatch(AdvertiserApi.actions.customers());
          }
        }));
      }
    });
  }

  render() {
    const { handleHide, isLoading, handleSubmit } = this.props;

    return (
      <form className="checkout" onSubmit={handleSubmit(this.submit)}>
        <Modal.Body>
          <div className="label-present form-group has-feedback">
            <label htmlFor="card" className="control-label">Card</label>
            <CardElement className='form-control' />
            <span className="help-block" />
          </div>
          <Field 
            type='text' 
            name='name' 
            placeholder='Name of the cardholder'
            label='Name' 
            component={InputField}
            validate={[required]}
          />
          <Field 
            type='text'
            name='address_line1' 
            placeholder='Street Address/PO Box/Company Name'
            label='Address' 
            component={InputField}
            validate={[required]}
          />
          <Field 
            type='text' 
            name='address_line2' 
            placeholder='Apartment/Suite/Unit/Building'
            label='Address Line 2' 
            component={InputField}
          />
          <div className="row">
            <div className="col-sm-5">
              <Field 
                type='text' 
                name='address_city' 
                placeholder='City'
                label='City' 
                component={InputField}
                validate={[required]}
              />
            </div>
            <div className="col-sm-3">
              <Field 
                type='text' 
                name='address_state' 
                placeholder='State'
                label='State'
                component={InputField}
                validate={[required]}
              />
            </div>
            <div className="col-sm-4">
              <Field 
                type='text' 
                name='address_country' 
                placeholder='Country'
                label='Country' 
                component={InputField}
                validate={[required]}
              />
            </div>
          </div>
        <div style={{ fontWeight: '800' }}>
          <FontAwesomeIcon icon="info-circle" />&nbsp;
          {
            // eslint-disable-next-line max-len
            'You may be charged a small fee to verify that your card is valid.  This is only temporary, you will be refunded the entire cost of the transaction.'
          }
        </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleHide}>Close</Button>
          <Button 
            type='submit' 
            loading={isLoading} 
            bsStyle='primary'
          >
            Add Card
          </Button>
        </Modal.Footer>
      </form>
    );
  }
}

const ResourceForm = reduxForm({
  form: 'CardForm'
});

export default connect()(injectStripe(ResourceForm(StripeForm)));
